import React from "react";
import { Container, Row, Col } from "reactstrap";
import heroImg from "../../assests/images/aparat.jpg";
import "./hero-section.css";

const HeroSection = () => {
  return (
    <section>
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="hero__content">
              <h3 className="mb-4 hero__title">
              Hozirgi paytda plastmassani <br /> qayta ishlash sanoati <br /> yangi usullar va uskunalarga 
              asoslangandir
              </h3>
              <p className="mb-5">
              QARSHI MUHANDISLIK-IQTISODIYOT INSTITUTI <br />
              «KIMYOVIY TEXNOLOGIYA» KAFEDRASI <br /> 
              KATTA O'QITUVCHISI TAVASHOV SHAHZOD
              </p>
            </div>
          
          </Col>

          <Col lg="6" md="6">
            <img src={heroImg} alt="" className="w-100 hero__img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
